import type { StyleRule } from '@archipro-design/aria';
import {
    avatarClassName,
    avatarSlotClassNames,
    professionalTileSlotClassNames,
    pxToRem,
} from '@archipro-design/aria';

export const ProfessionalsWrapper: StyleRule = {
    paddingTop: pxToRem(20),

    [`& .${professionalTileSlotClassNames.content} .${avatarClassName}`]: {
        justifyContent: 'center',
        [`& .${avatarSlotClassNames.image}`]: {
            display: 'block',
            width: '100%',
            height: '100%',
            '& > span': {
                display: 'block',
                width: '100%',
                height: '100%',
            },
        },
    },
};

export const ProfessionalTileLink: StyleRule = {
    width: pxToRem(414),
};
